<div style="display: block;" *ngIf="currentPrediction != null">
  <canvas mdbChart
          [chartType]="chartType"
          [datasets]="chartDatasets"
          [labels]="chartLabels"
          [colors]="chartColors"
          [options]="chartOptions"
          [legend]="false">
  </canvas>
</div>
